/* 
 *  Created by SGiri 02/14/2018
 */

export class Constants {

  public static locations: string[] = ["D1", "A3", "A", "L", "B3", "B2", "A2", "HEAD", "KPIS", "B1", "KPI", "A1"];

  public static gridStyle = { width: '100%', height: '100%' };

}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/util/app.constant.ts